<template>
  <div id="waitPrevoting">
    <v-card
      class="mx-auto"
      max-width="600"
      min-width="300"
      min-height="80"
      color="#f6f6fa"
    >
    <!-- <div v-if="havePrevote"> -->
    <p style="color:#FFFFFF;background-color:#5555BB"><b>総意の形成者</b></p>
    <div v-if="havePrevote && !done">
      <div class="text-area">
        <p>賛成か反対を選択し，<br>投票して下さい．</p>
        <v-container fluid>
          <v-row justify="center">
            <div class="agree">
              <agreeButton v-if="voted=='agree'" v-on:pushed="setVote('agree')" label="承認" active="true" />
              <agreeButton v-else v-on:pushed="setVote('agree')" label="承認" active="false" />
            </div>

            <div class="disagree">
              <disagreeButton v-if="voted=='disagree'" v-on:pushed="setVote('disagree')" label="否認" active="true" />
              <disagreeButton v-else v-on:pushed="setVote('disagree')" label="否認" active="false" />
            </div>
          </v-row>
        </v-container>
      </div>

      <div class="send-button">
        <sendButton v-if="voted=='agree'||voted=='disagree'" v-on:pushed="vote" label="投票する" active="true"/>
        <sendButton v-else label="投票する" active="false"/>
      </div>
    </div>
    <div v-else>
      <span v-on:click="showEffect(3)" class="plot-name"><b><u>総意の形成者</u></b></span>による投票を待っています．
    </div>
  </v-card>
  <missionMemberCard />
  </div>
</template>
<script>
import agreeButton from '@/components/gameUiComponents/AgreeButton.vue'
import disagreeButton from '@/components/gameUiComponents/DisagreeButton.vue'
import sendButton from '@/components/gameUiComponents/SendButton.vue'
import missionMemberCard from '@/components/gameComponents/cardComponents/MissionMemberCard.vue'
export default {
  name: "waitPrevoting",
  plops: [],
  components: {
    agreeButton,
    disagreeButton,
    sendButton,
    missionMemberCard,
  },
  data() {
    return {
      voted: '',
      assignedUsers: this.$store.getters.assignedUsers,
      roomId: this.$store.getters.roomId,
      userName: this.$store.getters.userName,
      userId: this.$store.getters.userId,
      socket: this.$store.state.webSocket.socket,
      done: false
    };
  },
  created() {
    this.$store.commit('setVoting')
    var self = this
    this.socket.onmessage = function(event){
      console.log("Received")
      console.log(event)
      const res = JSON.parse(event.data)
      if (!res.state) {return}

      if (res.state != 'wait-prevoting'){
        var prevotingUsers = []
        var snackText = "総意の形成者による投票結果は以下です．"
        for (var vote of res.data.votes){
          var votingUser = self.$store.getters.getUserById(vote.userId)
          votingUser.vote = vote.vote
          prevotingUsers.push(votingUser)

          snackText += "，\n" + votingUser.name + "："
          if (vote.vote == 'agree'){
            snackText += "承認"
          }else {
            snackText += "否認"
          }
        }
        snackText += ""
        self.$store.commit('setPrevotes', prevotingUsers)

        self.$emit("show-text", {state: "wait-prevoting", text: snackText})

        var nextState = "waitPrevoting"
        if (res.state == "wait-prevoting"){
          nextState = "waitPrevoting"
        }else if (res.state == "voting"){
          nextState = "voting"
        }

        self.$emit("proceed-state", nextState)
      }
      else {
        self.done = true
      }
    }
  },
  computed: {
    users: function() {
      return this.$store.state.userList.users;
    },
    havePrevote() {
      for (var i in this.users){
        if (this.users[i].id == this.userId){
          const plotCards = this.users[i].plots.filter(plot => plot.id == 3)
          if (plotCards.length > 0){
            return true
          }
        }
      }
      return false
    }
  },
  methods: {
    setVote(vote) {
      this.voted = vote
    },
    vote() {
      // this.sent = true
      this.$emit("send-request", {action:"prevote", roomId:this.roomId, userId:this.userId, data:{vote: this.voted}})
    },
    showEffect: function(id){
      var plot = this.$store.getters.getPlotEffect(id);
      var modalContent = {title: plot.name, text: plot.effect}
      this.$emit('send-modal', modalContent)
    },
  },
}
</script>
<style>
#waitPrevoting .send-button {
  padding-top: 12px;
  padding-bottom: 12px
}

#waitPrevoting .agree {
  margin-right: 12px
}

#waitPrevoting .assigned-card {
  margin-top: 12px;
}

#waitPrevoting .assigned-table {
  margin-bottom: 12px;
  align-items: center;
  display: inline-block;
  text-align:center;
  min-width: 200px
}
#waitPrevoting .plot-name {
  color: #5555BB;
  cursor:pointer;
}
</style>
